import React, { memo, useCallback } from "react";
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";

import { login } from "../../../redux/auth/actions";
import { FETCH_USER } from "../../../redux/user/actionType";
import LoginPage from "./LoginPage";

const LoginContainer = () => {
  const isLoading = useSelector(
    (state: RootStateOrAny) => state.auth.isLoading
  );
  const isAuthenticated = useSelector(
    (state: RootStateOrAny) => state.auth.authenticated
  );

  const user = useSelector((state: RootStateOrAny) => state.auth.user);

  const serverError = useSelector((state: RootStateOrAny) => state.auth.error);

  const request = useSelector(
    (state: RootStateOrAny) => state.requestStore?.[FETCH_USER]
  );

  const dispatch = useDispatch();
  const dispatchLogin = useCallback(
    (email: string, password: string) => dispatch(login(email, password)),
    [dispatch]
  );

  return (
    <LoginPage
      isAuthenticated={isAuthenticated}
      isLoading={isLoading}
      login={dispatchLogin}
      user={user}
      request={request}
      serverError={serverError}
    />
  );
};

export default memo(LoginContainer);
